import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

const navLinks = [
  { label: "Features", href: "#features" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Pricing", href: "#pricing" },
  { label: "Testimonials", href: "#testimonials" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-10 flex items-center justify-between h-16 md:h-18">
        <Link
          to="/"
          className={`flex items-center gap-2 text-xl md:text-2xl font-heading font-bold whitespace-nowrap hover:opacity-80 transition-opacity cursor-pointer ${
            scrolled ? "text-foreground-950" : "text-white"
          }`}
        >
          <img src="/images/logo.png" alt="EzyDinePro" className="h-12 md:h-14 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(link.href);
              }}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled
                  ? "text-foreground-700 hover:text-primary-500"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => navigate("/login")}
            className={`px-5 py-2 text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer rounded-md ${
              scrolled
                ? "text-foreground-700 hover:text-primary-500"
                : "text-white/90 hover:text-white"
            }`}
          >
            Log In
          </button>
          <button
            onClick={() => navigate("/login")}
            className="px-5 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
          >
            Get Started Free
          </button>
        </div>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-foreground-900" : "text-white"
          }`}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-3">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => {
                e.preventDefault();
                handleNavClick(link.href);
              }}
              className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors py-2 whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <div className="flex items-center gap-3 pt-2 border-t border-background-200">
            <button
              onClick={() => navigate("/login")}
              className="flex-1 px-4 py-2.5 text-sm font-semibold text-foreground-700 border border-background-300 rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Log In
            </button>
            <button
              onClick={() => navigate("/login")}
              className="flex-1 px-4 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}